/**
 * 操作按钮面板
 */

export type ActionType =
  | 'cultivate'
  | 'active_cultivate'
  | 'breakthrough'
  | 'technique'
  | 'combat_zone'
  | 'combat_attack'
  | 'combat_item'
  | 'combat_flee'
  | 'alchemy'
  | 'forge'
  | 'achievement'
  | 'sect'
  | 'explore_vein'
  | 'meridian'
  | 'shop'
  | 'save'
  | 'load'
  | 'delete_save';

export interface ActionButton {
  id: ActionType;
  text: string;
  cssClass: string;
  showInCombat: boolean;
  showOutOfCombat: boolean;
}

const PEACE_BUTTONS: ActionButton[] = [
  { id: 'cultivate', text: '🧘 修炼', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'active_cultivate', text: '⚡ 主动运功', cssClass: 'btn-primary', showInCombat: false, showOutOfCombat: true },
  { id: 'breakthrough', text: '🔮 突破', cssClass: 'btn-primary', showInCombat: false, showOutOfCombat: true },
  { id: 'technique', text: '📖 功法', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'alchemy', text: '🔥 炼丹', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'forge', text: '🔨 炼器', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'meridian', text: '🔮 经脉', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'achievement', text: '🏆 成就', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'sect', text: '🏯 宗门', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'combat_zone', text: '⚔️ 探索', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'explore_vein', text: '⛏️ 灵脉', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'shop', text: '🏪 坊市', cssClass: '', showInCombat: false, showOutOfCombat: true },
  { id: 'delete_save', text: '🗑️ 删档', cssClass: 'btn-danger', showInCombat: false, showOutOfCombat: true },
];

const COMBAT_BUTTONS: ActionButton[] = [
  { id: 'combat_attack', text: '🗡️ 攻击', cssClass: 'btn-primary', showInCombat: true, showOutOfCombat: false },
  { id: 'combat_item', text: '🧪 使用丹药', cssClass: '', showInCombat: true, showOutOfCombat: false },
  { id: 'combat_flee', text: '🏃 逃跑', cssClass: '', showInCombat: true, showOutOfCombat: false },
];

export class ActionPanel {
  private container: HTMLElement;
  private onAction: ((action: ActionType) => void) | null = null;
  private inCombat: boolean = false;
  private isDead: boolean = false;

  constructor(containerId: string) {
    const el = document.getElementById(containerId);
    if (!el) throw new Error(`Element #${containerId} not found`);
    this.container = el;
    this.container.className = 'panel';
  }

  setOnAction(callback: (action: ActionType) => void): void {
    this.onAction = callback;
    this.render();
  }

  setInCombat(inCombat: boolean): void {
    this.inCombat = inCombat;
    this.render();
  }

  setIsDead(isDead: boolean): void {
    this.isDead = isDead;
    this.render();
  }

  render(): void {
    let html = '<div class="panel-title">🎮 操作</div><div class="btn-group">';

    if (this.inCombat) {
      // 战斗模式：攻击 / 丹药 / 逃跑
      for (const btn of COMBAT_BUTTONS) {
        html += `<button class="btn ${btn.cssClass}" data-action="${btn.id}">${btn.text}</button>`;
      }
    } else {
      for (const btn of PEACE_BUTTONS) {
        html += `<button class="btn ${btn.cssClass}" data-action="${btn.id}">${btn.text}</button>`;
      }
    }

    html += '</div>';
    this.container.innerHTML = html;

    this.container.querySelectorAll('button[data-action]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const action = (btn as HTMLElement).dataset.action as ActionType;
        if (this.onAction) this.onAction(action);
      });
    });
  }
}
